export default "__VITE_ASSET__Dz_Z1K0H__"